import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div className='notfound d-flex justify-content-center align-items-center'>
           <div className=''>
           <h2>Page not Found</h2>
           
            <Link to='/'><button className='resume'>Go Back</button></Link>
           </div>
        </div>
    );
};

export default NotFound;